import { useEffect } from "react";
import { PageHeader } from "../components/PageHeader";
import { PillButton } from "../components/PillButton";

export default function NotFound() {
  useEffect(() => {
    document.title = "Pagina non trovata | Susanna Paoletti";
    let tag = document.querySelector('meta[name="robots"]');
    const prev = tag ? tag.getAttribute("content") : null;
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("name", "robots");
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", "noindex, follow");
    return () => {
      if (tag) tag.setAttribute("content", prev || "index, follow");
    };
  }, []);

  return (
    <>
      <PageHeader
        eyebrow="Errore 404"
        title="Pagina non trovata"
        subtitle="La pagina che cerchi non esiste o è stata spostata. Puoi tornare alla home o contattarmi direttamente."
      />
      <section className="py-16 md:py-24" data-testid="not-found">
        <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col sm:flex-row gap-4">
          <PillButton to="/" testid="notfound-home">Torna alla home</PillButton>
          <PillButton to="/contatti" variant="outline" testid="notfound-contatti">Richiedi informazioni</PillButton>
        </div>
      </section>
    </>
  );
}
